import React, { useState } from 'react';
import PuzzleGrid from './PuzzleGrid';
import { getDifficulty } from '../utils/puzzleUtils';

const AvailablePuzzles = ({ puzzles, onAddPuzzle }) => {
  const [filters, setFilters] = useState({ difficulty: '', gridSize: '' });
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPuzzles = puzzles.filter(puzzle => 
    (filters.difficulty ? getDifficulty(puzzle.fice_score) === filters.difficulty : true) &&
    (filters.gridSize ? puzzle.pattern.length === parseInt(filters.gridSize) : true) &&
    (searchTerm ? puzzle.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  puzzle.board_number.toLowerCase().includes(searchTerm.toLowerCase()) : true)
  );

  return (
    <div className="available-puzzles">
      <h2>Available Puzzles</h2>
      <div className="puzzle-filters">
        <select 
          value={filters.difficulty} 
          onChange={(e) => setFilters({...filters, difficulty: e.target.value})}
        >
          <option value="">All Difficulties</option>
          <option value="Easy">Easy</option>
          <option value="Medium">Medium</option>
          <option value="Hard">Hard</option>
          <option value="Expert">Expert</option>
        </select>
        <select 
          value={filters.gridSize} 
          onChange={(e) => setFilters({...filters, gridSize: e.target.value})}
        >
          <option value="">All Sizes</option>
          <option value="4">4x4</option>
          <option value="8">8x8</option>
        </select>
        <input 
          type="text" 
          placeholder="Search puzzles..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <PuzzleGrid 
        puzzles={filteredPuzzles} 
        onPuzzleClick={onAddPuzzle}
      />
    </div>
  );
};

export default AvailablePuzzles;